import { Component, OnInit, Inject } from '@angular/core';
import { isUndefined } from 'util';
import { MatDialogRef , MAT_DIALOG_DATA } from "@angular/material";

import { RestApiService } from "../shared/restApiServices/restapi.service";
import { ShowToastyService } from "../shared/services/showToastyService";

@Component({
  selector: 'app-verify-mail-idmodal',
  templateUrl: './verify-mail-idmodal.component.html',
  styleUrls: ['./verify-mail-idmodal.component.css']
})
export class VerifyMailIdmodalComponent implements OnInit {

  name:string = '';
  email:string = '';
  code:string = '';
  token:string = '';

  codeEmpty:string = '';
  verify:boolean = false;
  failMsg: string = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data : any, private dialogRef:MatDialogRef<VerifyMailIdmodalComponent>, private restApiService:RestApiService, private showToastyService:ShowToastyService) {
    this.name = this.data['name'];
    this.email  = this.data['email'];
    this.token = this.data['token']
   }

  ngOnInit() {
  }

  proceed() {
    this.restApiService.sendVerificatiopnCodeOnMail(this.token).subscribe(res => {
      if (res.success == true) {
        this.verify = true;
      }
      else {
        this.failMsg = res.value;
      }
    })
  }

  onVerify() {
    this.codeEmpty = '';
    if(!Boolean(this.code) || this.code.length < 1)
    {
      this.codeEmpty = 'on-error';
    }
    else{
      this.restApiService.confirmMailUpdate( this.token ,this.code).subscribe(result=>{
        if(result.success == false){
          this.failMsg = result.value;
        }
        else{
          this.showToastyService.success('Successfully Verified' , '')
          this.dialogRef.close(result);
        }
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/verify-mail-idmodal/verify-mail-idmodal.component.ts